import React from 'react';

const InvoiceGraphBottom = (props) => {
  const { billDate, billUrl, isMobileOrWeb, index } = props;
  //method to convert date format
  const dateMonth = () => {
    let day = billDate.charAt(0) + billDate.charAt(1);
    let year = billDate.charAt(6) + billDate.charAt(7);
    let month = billDate.charAt(3) + billDate.charAt(4);
    let newMonth = '';
    if (month === '01') newMonth = 'ינו';
    else if (month === '02') newMonth = 'פבר';
    else if (month === '03') newMonth = 'מרץ';
    else if (month === '04') newMonth = 'אפר';
    else if (month === '05') newMonth = 'מאי';
    else if (month === '06') newMonth = 'יונ';
    else if (month === '07') newMonth = 'יול';
    else if (month === '08') newMonth = 'אוג';
    else if (month === '09') newMonth = 'ספט';
    else if (month === '10') newMonth = 'אוק';
    else if (month === '11') newMonth = 'נוב';
    else if (month === '12') newMonth = 'דצמ';

    let date = day + ' ' + newMonth + ' ' + year;
    return date;
  };

  let currDate = dateMonth();
  if (props.index != 0) {
    return (
      <div className='graphBoxBottom'>
        <div className='invoiceGraph_billDate' onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}>
          {currDate}
        </div>
      </div>
    );
  }
  else if (props.index == 0) {
    return (
      <div className='graphBoxBottom'>
        <div className='invoiceGraph_billDate_first' onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}>
          {currDate}
        </div>
      </div>
    );
  }
};

export default InvoiceGraphBottom;
